import { SelectionFamilyReference } from './internal';
export class SelectionFamilyReferenceAdoption extends SelectionFamilyReference {
    getAdoptedByWhom() {
        return this.get("ADOP" /* Tag.Adoption */);
    }
}
//# sourceMappingURL=SelectionFamilyReferenceAdoption.js.map